export default function NewBadge() {
  return (
    <span className="inline-flex items-center rounded-full bg-vivatis-600 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white shadow-sm animate-pulse">
      NEW
    </span>
  );
}
